import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  FutureVisionSection,
  ContentWrapper,
  TextContent,
  SectionTitle,
  SectionDescription,
  ImageContent
} from './styles';

const FutureVision: React.FC = () => {
  const { language } = useLanguage();
  return (
    <FutureVisionSection>
      <div className="container">
        <ContentWrapper>
          <TextContent>
            <SectionTitle>
              {language === 'pt' 
                ? 'TRANSFORMANDO IDEIAS EM SOLUÇÕES TECNOLÓGICAS DE IMPACTO'
                : 'TRANSFORMING IDEAS INTO IMPACTFUL TECHNOLOGICAL SOLUTIONS'}
            </SectionTitle>
            <SectionDescription>
              {language === 'pt' ? (
                <>
                  <p>
                    Na Tech By Tech, somos especialistas em transformar conceitos inovadores em soluções tecnológicas 
                    que impulsionam negócios e melhoram a vida das pessoas. Nossa equipe de profissionais altamente 
                    qualificados combina expertise técnica com visão estratégica para desenvolver produtos e serviços 
                    que atendem às necessidades específicas de cada cliente.
                  </p>
                  <p>
                    Nosso portfólio diversificado inclui sistemas de gestão empresarial, plataformas de identificação 
                    digital, soluções para o setor de saúde e muito mais. Utilizamos as mais avançadas tecnologias, 
                    como inteligência artificial, reconhecimento facial e análise de dados, para criar ferramentas 
                    poderosas e intuitivas.
                  </p>
                  <p>
                    Acreditamos que a tecnologia deve ser acessível, segura e eficiente. Por isso, trabalhamos 
                    incansavelmente para desenvolver soluções que não apenas resolvam problemas atuais, mas também 
                    antecipem desafios futuros, garantindo que nossos clientes estejam sempre à frente em seus setores.
                  </p>
                </>
              ) : (
                <>
                  <p>
                    At Tech By Tech, we specialize in transforming innovative concepts into technological solutions 
                    that drive businesses and improve people's lives. Our team of highly qualified professionals 
                    combines technical expertise with strategic vision to develop products and services 
                    that meet the specific needs of each client.
                  </p>
                  <p>
                    Our diversified portfolio includes business management systems, digital identification platforms, 
                    healthcare solutions, and much more. We use the most advanced technologies, 
                    such as artificial intelligence, facial recognition, and data analysis, to create powerful 
                    and intuitive tools.
                  </p>
                  <p>
                    We believe that technology should be accessible, secure, and efficient. That's why we work 
                    tirelessly to develop solutions that not only solve current problems but also 
                    anticipate future challenges, ensuring that our clients are always ahead in their sectors.
                  </p>
                </>
              )}
            </SectionDescription>
          </TextContent>
          
          <ImageContent>
            <img src="/back_imgs/balls.png" alt="Tech By Tech Vision" style={{ width: '100%', height: 'auto', borderRadius: '10px' }} />
          </ImageContent>
        </ContentWrapper>
      </div>
    </FutureVisionSection>
  );
};

export default FutureVision;